<template>
    <div>
        <page-header v-if="!$route.meta.noLayout" class="hidden-print"></page-header>
        <notify class="hidden-print"></notify>
        <router-view></router-view>
        <cart></cart>
        <page-footer v-if="!$route.meta.noLayout" class="hidden-print"></page-footer>
        <confirmation-modal></confirmation-modal>
        <alert-modal></alert-modal>
    </div>
</template>

<script>
    import PageHeader from './partials/PageHeader.vue';
    import Notify from './partials/Notify.vue';
    import PageFooter from './partials/PageFooter.vue';
    import Cart from './partials/Cart.vue';
    import AlertModal from './widgets/AlertModal.vue';
    import ConfirmationModal from './widgets/ConfirmationModal.vue';

    export default {
        name: 'app',
        components: {'cart': Cart, 'page-header': PageHeader, 'notify': Notify, 'page-footer': PageFooter, 'confirmation-modal': ConfirmationModal, 'alert-modal': AlertModal},
    }
</script>